import React from 'react';
import { Button } from '@material-tailwind/react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav/Nav';
import Footer from '../components/Footer/Footer';

export default function Error404() {
  const navigate = useNavigate();

  return (
    <div className='w-dvw h-dvh bg-background-img bg-cover bg-repeat flex justify-center items-center'>
      <Nav />
      <div className='max-w-[80rem] w-full md:w-auto md:min-w-[50rem] max-h-[20rem] min-h-[20rem] h-full m-4 mt-8 bg-offwhite rounded-xl shadow-all flex flex-col'>
        <div className='p-4 w-full h-full text-center flex flex-col justify-between'>
          <span></span>
          <span className="text-4xl font-light">Upload not found</span>
          <Button onClick={() => navigate("/")}>
            Click here to upload
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  )
}
